import Layout from '@eduzz/ui-layout';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import ChatMessages from 'v2/components/Shared/ChatMessages';
import Environment from 'v2/components/Shared/Environment';
import HyperflowChat from 'v2/components/Shared/Hyperflow';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import Affiliations from './Affiliations';
import iconMyEduzz from './myeduzz-symbol.svg';
import logoMyEduzz from './myeduzz.svg';
import NoPartner from './NoPartner';
import Notifications from './Notifications';
import ProfileMenu from './ProfileMenu';

const { Topbar } = Layout;

type LogoWrapperProps = {
  className: string;
  children: React.ReactNode;
};
function LogoWrapper({ className, children }: LogoWrapperProps) {
  return (
    <Link className={className} to='/producer/dashboard'>
      {children}
    </Link>
  );
}

function Toolbar() {
  const [ModuleTopbarSearch] = useObservable(() => {
    return eduzzAccountsService.getUserVertical().pipe(
      switchMap((user) => {
        return from(
          import('@myeduzz-vertical/root/modules').then(async (d) => {
            return {
              modules: await d.getModules(user as any),
              verticalUser: user,
            };
          })
        );
      }),
      map(({ modules, verticalUser }) => {
        return {
          verticalUser,
          Component: modules.find((m) => m.name === 'global-search')?.topbarSearch,
        };
      })
    );
  }, []);

  const [user] = useObservable(() => eduzzAccountsService.getUserToolbar(), []);
  const [userDetails] = useObservable(() => eduzzAccountsService.getUser(), []);
  const canSeeHyperflowChat = userDetails?.is_elite || userDetails?.has_chat_black || userDetails?.is_clube_black;

  if (!user) {
    return null;
  }

  return (
    <Topbar
      currentApplication='orbita'
      disableApps={!user.isPartner}
      user={user}
      logo={logoMyEduzz}
      logoMobile={iconMyEduzz}
      logoWrapper={LogoWrapper}
    >
      {canSeeHyperflowChat && <HyperflowChat />}

      {ModuleTopbarSearch?.Component && (
        <React.Suspense fallback={<></>}>
          <ModuleTopbarSearch.Component SearchComponent={Topbar.Search} React={React} user={ModuleTopbarSearch.verticalUser} runOnOrbita />
        </React.Suspense>
      )}

      {user.isPartner ? (
        <>
          <PermissionHide>
            <Affiliations />
          </PermissionHide>

          <PermissionHide action='myeduzz:meus-afiliados:visualizar'>
            <ChatMessages />
          </PermissionHide>

          <Notifications />
          <Environment />
        </>
      ) : (
        <NoPartner />
      )}

      <ProfileMenu />
    </Topbar>
  );
}

export default React.memo(Toolbar);
